// extracted by mini-css-extract-plugin
export default {"v-local-padding":"16px","links":"JG3UmNJ","linksItem":"QlKGsHv"};